var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GeoJSON, TileLayer, Tooltip, useMap } from 'react-leaflet';
import L from 'leaflet';
import { useEffect, useState } from "react";
import { bbox, featureCollection } from "@turf/turf";
var iconProps = {
    iconUrl: 'https://unpkg.com/leaflet@1.6.0/dist/images/marker-icon-2x.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.6.0/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
};
var blueIcon = L.icon(iconProps);
var blueMarker = function (geoJsonPoint, latlng) {
    return new L.Marker(latlng, { icon: blueIcon });
};
export default function ManifestMap(_a) {
    var manifests = _a.manifests, focus = _a.focus;
    var _b = useState(null), geoJsonComponent = _b[0], setGeoJsonComponent = _b[1];
    var map = useMap();
    useEffect(function () {
        var _a, _b;
        var geoJson = manifests.map(function (manifest) { var _a, _b; return (_b = (_a = manifest.navPlace()) === null || _a === void 0 ? void 0 : _a['features']) === null || _b === void 0 ? void 0 : _b[0]; });
        var labels = manifests.map(function (manifest) { return manifest.label(); });
        if (geoJson === null || geoJson.length === 0) {
            setGeoJsonComponent([]);
            map.fitWorld();
        }
        else {
            setGeoJsonComponent(geoJson.map(function (data, index) { return (_jsx(GeoJSON, __assign({ data: data, pointToLayer: blueMarker, style: { color: 'blue' } }, { children: _jsx(Tooltip, { children: labels[index] }, void 0) }), "ManifestMap:" + manifests[index].uri)); }));
            var focusBounds = (_b = (_a = focus === null || focus === void 0 ? void 0 : focus.navPlace()) === null || _a === void 0 ? void 0 : _a['features']) === null || _b === void 0 ? void 0 : _b[0];
            var allBounds = bbox(featureCollection((focusBounds !== undefined) ? [focusBounds] : geoJson));
            map.fitBounds([[allBounds[1], allBounds[0]], [allBounds[3], allBounds[2]]]);
        }
    }, [manifests, map]);
    return (_jsxs(_Fragment, { children: [_jsx(TileLayer, { url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png" }, void 0), geoJsonComponent] }, void 0));
}
